import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function(element) {
    gsap.from(element.querySelectorAll(".grass-1, .grass-2"), {
        scrollTrigger: {
            trigger: element,
            start: "top center",
        },
        x: 120,
        y: 40,
        scale: 0.6,
        opacity: 0,
        duration: 1,
        ease: "power4.out",
        stagger: 0.1
    });
    gsap.from(element.querySelectorAll(".grass-3, .grass-4"), {
        scrollTrigger: {
            trigger: element,
            start: "top center",
        },
        x: -120,
        y: 40,
        scale: 0.6,
        opacity: 0,
        duration: 1,
        ease: "power4.out",
        stagger: 0.1
    });
};